export function listAll(type, opts = {}) {
  const designSystemList = [
    'reset',
    'sequence',
    'unit',
    'font',
    'font_family',
    'font_face',
    'media',
    'gradient',
    'shadow',
    'icons',
    'semantic_icons',
    'timing',
    'document',
    'breakpoints',
    'devices',
    'cases',
    'animation',
    'svg',
    'grid',
    'class'
  ]

  const designSystem =
    opts.activeFileSidebar === 'Local'
      ? this.getDesignSystem()
      : opts.designSystem

  // default
  if (designSystemList.includes(type)) {
    return designSystem[type]
  }

  // specific logics
  if (type === 'color') {
    const allColors = designSystem[type]
    return (
      allColors &&
      Object.entries(allColors).reduce((initial, [key, value]) => {
        if (this.call('isString', value)) {
          return { ...initial, [key]: value }
        }
        return initial
      }, {})
    )
  }
  if (type === 'semantic_color') {
    const allColors = designSystem.color
    return (
      allColors &&
      Object.entries(allColors).reduce((initial, [key, value]) => {
        if (!this.call('isString', value)) {
          return { ...initial, [key]: value }
        }
        return initial
      }, {})
    )
  }
  if (type === 'theme') {
    const allThemes = designSystem[type]
    return (
      allThemes &&
      Object.entries(allThemes).reduce((initial, [key, value]) => {
        if (key !== 'document') {
          return { ...initial, [key]: value }
        }
        return initial
      }, {})
    )
  }
  if (type === 'global_theme') {
    return designSystem.theme?.document
  }
  if (type === 'spacing') {
    return this.filterKeys(designSystem.spacing, true)
  }
  if (type === 'typography') {
    return this.filterKeys(designSystem.typography, true)
  }
  if (type === 'templates') {
    return this.filterKeys(designSystem.typography?.templates, false)
  }

  return opts[type]
}

export function filterKeys(obj, keepAt = false) {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => (key[0] === '@') === keepAt)
  )
}

export function listAllAsArray(type, opts = {}) {
  const data = this.call('listAll', type, opts)

  if (!data) {
    return []
  }

  const res = Object.keys(data).reduce((initial, key) => {
    const map = {
      key,
      type,
      value: data[key],
      ...(opts.withSchema ? {} : {})
    }

    if (!opts.search) {
      return [...initial, map]
    }

    if (
      key.toLowerCase().includes(opts.search.toLowerCase()) ||
      (typeof data[key] === 'string' &&
        data[key].toLowerCase().includes(opts.search.toLowerCase()))
    ) {
      return [...initial, map]
    }

    return initial
  }, [])

  if (!res.length && opts.search) {
    this.state.update({ noResults: true })
  }

  if (opts.sort && opts.sortIf) {
    return res.sort(opts.sort)
  }

  return res
}

export async function listSidebar(type, opts = { activeFileSidebar: 'Local' }) {
  const activeFileSidebar = opts.activeFileSidebar || 'Local'
  const data = await this.call(
    'getDynamicIslandDataByCategory',
    activeFileSidebar
  )

  const isLocal = activeFileSidebar === 'Local'
  const designSystem = isLocal ? this.getDesignSystem() : opts.designSystem
  return this.call('listAllAsArray', type, {
    withSchema: false,
    ...opts,
    activeFileSidebar,
    ...data
  }).filter((v) => {
    const allowGlobals = ['dependencies', 'secrets']
    if (allowGlobals.includes(type)) {
      return true
    }

    if (designSystem?.[type]) {
      return true
    }

    // TODO: remove components when variants are implemented
    const dotsAllowedList = ['files', 'dependencies', 'secrets', 'components']
    if (!dotsAllowedList.includes(type) && v.key.includes('.')) {
      return false
    }

    if (opts.search) {
      return true
    }

    if (
      isLocal &&
      ['pages', 'components'].includes(type)
      // ['pages', 'components', 'functions', 'state', 'files'].includes(type)
    ) {
      return this.call('inOnCurrentCanvasPage', type, v.key)
    }

    return true
  })
}
